import { cn } from '@cobliteam/ui/utils';
import { Thumb } from '@radix-ui/react-slider';

import type React from 'react';
import { forwardRef } from 'react';

interface SliderThumbProps {
  ref: React.RefObject<HTMLDivElement>;
  isStart?: boolean;
  onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
  onPointerUp: (event: React.PointerEvent<HTMLDivElement>) => void;
}

/**
 * Renders a draggable thumb for the slider component
 * With different styling for start and end thumbs
 */
const SliderThumb = forwardRef<HTMLDivElement, SliderThumbProps>(({ isStart = false, onPointerDown, onPointerUp }, ref) => {
  return (
    <Thumb
      ref={ref}
      className={cn(
        // Common styles
        'box-content block h-3 w-px cursor-grab rounded-sm border-primary border-y-[6px] bg-white active:cursor-grabbing',
        // Different border widths for start vs end thumbs
        isStart ? 'border-r-[4px] border-l-[6px]' : 'border-r-[6px] border-l-[4px]'
      )}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
    />
  );
});

export default SliderThumb;
